<template>
  <div>
    
    <v-container v-if="grid">
      <v-row align="center" justify="space-around">
        <v-col :cols="gridSize" v-for="item in filteredItems" :key="item.id">
          <!-- <v-img class="cursor-pointer" :src="item.download_url" contain @click="preview(item)"></v-img> -->
          <v-img class="cursor-pointer" :src="item.download_url" contain @click="preview(item)"></v-img>
        </v-col>
      </v-row>
    </v-container>

    <Container lock-axis="y" @drop="onDrop" v-else>
      <Draggable v-for="(item, idx) in items" :key="item.id">
        <v-row justify="space-around" class="draggable-item">
          <v-col cols="11">
            <v-card style="cursor: grab">
              <v-card-text class="py-0">
                <v-row align="center" justify="space-around" class="text-center">
                  <v-col cols="1">
                    {{ idx + 1 }}
                  </v-col>
                  <v-col cols="2">
                    <!-- <v-img class="cursor-pointer" :src="item.download_url" contain @click="preview(item)"></v-img> -->
                    <v-img
                      class="cursor-pointer"
                      :src="item.download_url"
                      contain @click="preview(item)"
                      style="z-index: 6;"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0 grey lighten-5" align="center" justify="center" >
                          <v-progress-circular indeterminate color="grey"/>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                  <v-col cols="4">
                    {{ item.name }}
                  </v-col>
                  <v-col cols="3">
                    <!-- {{ moment().format('DD-MM-YYYY') }} -->
                  </v-col>
                  <v-col cols="2">
                    <v-icon @click="item.show = !item.show" v-if="item.show">mdi-eye-off</v-icon>
                  </v-col>
                </v-row>
                <v-overlay absolute :value="!item.show">
                  <v-row align="center" class="text-center px-4">
                    <v-col offset="10" cols="2">
                      <v-icon @click="item.show = !item.show">mdi-eye</v-icon>
                    </v-col>
                  </v-row>
                </v-overlay>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </Draggable>
    </Container>

    <!-- Image Preview -->
    <image-preview
      v-model="previewDialog"
      :item="image"
      @close="previewDialog = false"
    />

    <!-- Confirmation -->
    <confirmation
      v-model="dialog"
      title="Eliminar imagen"
      text="Desea eliminar la imagen"
      :item="itemToDelete.name"
      @close="close()"
      @confirm="deleteItem()"
    />

  </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
import Confirmation from "@/components/Confirmation";
import ImagePreview from "@/components/ImagePreview";

export default {
  props: {
    type: String,
    imageType: String,
    grid: { type: Boolean, default: false },
    damage: { type: Number, default: null },
    images: { type: Array, default: () => [] },
    selected: { type: Array, default: null }
  },
  components: {
    Container,
    Draggable,
    Confirmation,
    ImagePreview
  },
  data: () => ({
    dialog: false,
    previewDialog: false,
    itemToDelete: {},
    image: {},
    items: [],
    // stage: {
    //   before: [
    //     {
    //       name: 'DSCN6549.jpg'
    //     },
    //     {
    //       name: 'DSCN6551.jpg'
    //     }
    //   ],
    //   while: [
    //     {
    //       name: 'DSCN6550.jpg'
    //     },
    //     {
    //       name: 'DSCN6553.jpg'
    //     },
    //     {
    //       name: 'DSCN6555.jpg'
    //     },
    //     {
    //       name: 'DSCN6556.jpg'
    //     }
    //   ],
    //   after: [
    //     {
    //       name: 'DSCN6564.jpg'
    //     },
    //     {
    //       name: 'DSCN6565.jpg'
    //     }
    //   ]
    // }
  }),
  watch: {
    images(val) {
      if (val && val.length) this.init()
    }
  },
  computed: {
    // items: {
    //   get () {
    //     return this.stage[this.images]
    //   },
    //   set (val) {
    //     this.stage[this.images] = val
    //   }
    // }
    gridSize () {
      // return this.$store.state.reports.gridSize[this.imageType]
      return this.items.length > 1 ? 6 :12
    },
    filteredItems() {
      return this.items.filter(element => element.show)
    }
  },
  methods: {
    init() {
      if (this.images.length) {
        const images = this.images.map(element => {
          return {
            ...element,
            show: true
          }
        })
        this.items = JSON.parse(JSON.stringify(this.selected ? this.selected : images))
      }
      this.onChange()
    },
    onChange () {
      const body = {
        type: this.type,
        images: this.items
      }
      this.$emit('change', body)
    },
    preview (item) {
      this.image = item
      this.previewDialog = true
    },
    close () {
      this.dialog = false
      this.itemToDelete = {}
    },
    confirmDelete (item) {
      this.itemToDelete = item
      this.dialog = true
    },
    deleteItem () {
      const idx = this.items.indexOf(this.itemToDelete)
      this.items.splice(idx, 1)
      this.close()
      this.onChange()
    },
    onDrop(dropResult) {
      this.items = this.applyDrag(this.items, dropResult);
      this.onChange()
    },
    applyDrag (arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult
      if (removedIndex === null && addedIndex === null) return arr
      const result = [...arr]
      let itemToAdd = payload
      if (removedIndex !== null) itemToAdd = result.splice(removedIndex, 1)[0]
      if (addedIndex !== null) result.splice(addedIndex, 0, itemToAdd)
      return result
    }
  },
  created () {
    this.init()
  }
};
</script>